import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import App from './App.vue'
import store from './store/index'
import {routes} from './routes/routes'
import { registerComponents, registerFirebase } from './utils'

Vue.config.productionTip = false

Vue.use (Vuetify, {
	theme: {
		primary: '#20293E',
		secondary: '#182030',
		accent: '#82B1FF',
		error: '#D9374C',
		info: '#2196F3',
		success: '#1FBD5F',
		warning: '#FFC107'
	}
})

Vue.use (VueRouter)

registerComponents ()
registerFirebase ()

const router = new VueRouter ({
	mode: 'history',
	routes
})

new Vue ({
	router,
	store,
	render: h => h (App)
}).$mount ('#app')
